import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { SuppliersBasketStore } from '@lib/shared/basket-service/suppliers-basket/data-access';
import {
    BasketItemRequest,
    CompanySetting, SupplierBasket, TotalBasket,
} from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';
import {
    IBudgetExceedance,
    IPurchasingGroupAssignmentIssue,
    IPurchasingGroupResolution,
} from '@lib/shared/basket-service';

@Component({
    selector: 'suppliers-basket-feature',
    templateUrl: './suppliers-basket-feature.component.html',
    standalone: false
})
export class SuppliersBasketFeatureComponent implements OnInit {
    suppliersBasketStore = inject(SuppliersBasketStore);

    supplierBaskets$!: Observable<SupplierBasket[] | []>;
    currencyTotals$!: Observable<TotalBasket[] | []>;
    companySetting$!: Observable<CompanySetting | null>;

    @Input() isEditableStep!: boolean;
    @Input() showStepperButtons!: boolean;
    @Input() basketToggleStatus!: boolean;
    @Input() budgetOverruns: IBudgetExceedance[] | null = [];
    @Input() purchasingGroupAssignmentIssues: readonly IPurchasingGroupAssignmentIssue[] = [];
    @Input() resolvedPurchasingGroups: readonly IPurchasingGroupResolution[] = [];
    @Input() purchasingGroupVisible = true;
    @Input() purchasingGroupValidationLoading = false;
    @Input() companyCodeId: string | null = null;

    @Output() nextClicked = new EventEmitter();
    @Output() validityChanged = new EventEmitter<boolean>();
    @Output() addressSelectionOpened = new EventEmitter<void>();
    @Output() basketQuantityUpdated = new EventEmitter<BasketItemRequest>();

    ngOnInit() {
        this.loadBasket();
        this.getCompanySetting();
        this.streamSupplierBaskets();
        this.streamCurrencyTotals();
        this.streamCompanySetting();
        this.suppliersBasketStore.getMaxUploadSize$();
    }

    onClickNext(): void {
        this.validityChanged.next(true);
        this.nextClicked.emit();
    }

    openAddressSelection(): void {
        this.nextClicked.emit();
    }

    onValidityChange(isValid: boolean): void {
        this.validityChanged.next(isValid);
    }

    private loadBasket(): void {
        this.suppliersBasketStore.loadBasket$();
    }

    private getCompanySetting(): void {
        this.suppliersBasketStore.getCompanySetting$();
    }

    private streamSupplierBaskets(): void {
        this.supplierBaskets$ = this.suppliersBasketStore.supplierBaskets;
    }

    private streamCurrencyTotals(): void {
        this.currencyTotals$ = this.suppliersBasketStore.currencyTotals;
    }

    private streamCompanySetting(): void {
        this.companySetting$ = this.suppliersBasketStore.companySetting;
    }
}
